import { get } from 'lodash-es';

export const draftModuleSelector = (state) => state.draftModule;

export const getDraftState = (state) => state.draft;

export const getDraft = (draft) => draft.data;

export const getDraftId = (draft) => get(draft, 'draftId', '');

export const getDraftName = (draft) => get(draft, 'name');
